<div class="thank-you-container">
    <kzn-status-message heading="Thank You!" message="Your submission has been successfully completed."
        [isSuccess]="true"></kzn-status-message>
    <div #pdfContainer class="pdf-container"></div>
</div>